module.exports = __webpack_public_path__ + "img/img15.1e99d93a.png";